import _IconButton from "@material-ui/core/esm/IconButton";
import React, { useState } from 'react';
import classnames from 'classnames';
import { handleOnEscapeAndEnterPressed } from 'swag-client-common/utils/ui.utils';
import { AccountDropdown } from '../account-dropdown';
import classes from './user-links.scss';
import UserLinksGuest from './user-links-guest';
import { getIcon } from './get-icon';
export const UserLinks = ({
  name,
  isLoggedIn,
  onLogoutClick,
  onSignupClick,
  onLoginClick,
  userRole,
  isViolet,
  useHardLinks,
  routeNavigationConfirmation,
  orderApprovalFlow,
  userIsHeadOfCompanyDepartment,
  inventoryId,
  showInventoryLink,
  isApiAccessEnabled,
  shouldHideUserLinks
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleKeyPress = event => {
    return handleOnEscapeAndEnterPressed({
      event,
      onEnterCallback: () => setIsDropdownOpen(true),
      onEscapeCallback: () => setIsDropdownOpen(false)
    });
  };
  const handleLastLinkKeyUp = () => {
    setIsDropdownOpen(false);
  };
  const handleMouseEnter = () => {
    setIsDropdownOpen(true);
  };
  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };
  if (isLoggedIn) {
    return /*#__PURE__*/React.createElement("span", {
      tabIndex: 0,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      className: classnames(classes.link, classes.accountLink, {
        [classes.hideUserLinks]: shouldHideUserLinks
      }),
      onKeyDown: handleKeyPress
    }, /*#__PURE__*/React.createElement(_IconButton, {
      disableRipple: true,
      className: classes.userButton,
      size: "small",
      "aria-label": "cart",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement("img", {
      alt: "User icon",
      src: getIcon(),
      className: classes.icon
    })), /*#__PURE__*/React.createElement("span", {
      className: classes.title
    }, " Welcome, ", name || 'Anonymous'), /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.accountLinkIcon, {
        [classes.violet]: isViolet
      })
    }), /*#__PURE__*/React.createElement(AccountDropdown, {
      isOpen: isDropdownOpen,
      onLogOut: onLogoutClick,
      userRole: userRole,
      className: classes.accountDropdown,
      useHardLinks: useHardLinks,
      routeNavigationConfirmation: routeNavigationConfirmation,
      orderApprovalFlow: orderApprovalFlow,
      userIsHeadOfCompanyDepartment: userIsHeadOfCompanyDepartment,
      inventoryId: inventoryId,
      showInventoryLink: showInventoryLink,
      isApiAccessEnabled: isApiAccessEnabled,
      handleLastLinkKeyUp: handleLastLinkKeyUp
    }));
  }
  return /*#__PURE__*/React.createElement(UserLinksGuest, {
    onLoginClick: onLoginClick,
    onSignUpClick: onSignupClick,
    shouldHideUserLinks: shouldHideUserLinks
  });
};